import { DatePipe } from '@angular/common';
import { ChangeDetectorRef, Component, OnInit, QueryList, ViewChildren } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { DealerWiseCallHistoryResponse } from 'projects/Administration/src/app/business-entities/call-dealer-logs-model';
import { Filter } from 'projects/Administration/src/app/business-entities/Filter';
import { PagerData } from 'projects/Administration/src/app/business-entities/PagerData';
import { CallDealerLogsService } from 'projects/Administration/src/app/business-services/call-dealer-logs.service';
import { DashboardService } from 'projects/Administration/src/app/business-services/dashboard.service';
import { PaginationService } from 'projects/Administration/src/app/services/pagination.service';
import { NgbdSortableHeader, SortEvent } from 'projects/Autofacets-Core/src/app/directives/sortable.directive';
import { Constant } from 'projects/Autofacets-Core/src/app/utils/constant';
import { UserDataService } from 'src/app/DataServices/user-data.service';
import { Application } from 'projects/Autofacets-Core/src/app/utils/enums';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CallDealerLogsComponent } from '../call-dealer-logs.component';
import { ExcelService } from 'projects/Autofacets-Core/src/app/common-services/export-excel.service';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import { BsDaterangepickerConfig } from 'ngx-bootstrap/datepicker';
@Component({
  selector: 'app-dealer-wise-call-history',
templateUrl: './dealer-wise-call-history.component.html'
  
})
export class DealerWiseCallHistoryComponent implements OnInit {
  searchTerm: string;
  dealerWiseCallHistoryList: DealerWiseCallHistoryResponse[] = [];
  totalCount: number = 0;
  scrollDistance = 1;
  throttle = 100;

  pagerData: PagerData = {
    page: 1,
    pagerSize: 25,
  };
  pager: any = {};
  pagedItems: any[];
  dataRows: any[] = [];
  filterItems: any[];
  filter: Filter = new Filter();
  dropdownSettings: {};
  selectedDate: any[] = [];
  dealerList: any[] = [];
  selectedDealers: any[] = [];
  dataList: DealerWiseCallHistoryResponse[] = []; 
  myDateRangePickerOptions: Partial<BsDaterangepickerConfig> = Object.assign({},{
    containerClass: 'theme-dark-blue',
    displayMonths:1,
    showWeekNumbers:false,
    rangeInputFormat: 'DD/MM/YYYY',
    customTodayClass: 'custom-today-class'
  });
  Applications:any
  hideColumn : boolean= false;
  @ViewChildren(NgbdSortableHeader) headers: QueryList<NgbdSortableHeader>;
  constructor(    
    private spinner: NgxSpinnerService,
    private callDealerLogsService: CallDealerLogsService,
    private pagerService: PaginationService,
    private userService: UserDataService,
    private dashboardService: DashboardService,
    private datePipe: DatePipe,
    private translate: TranslateService,
    private toaster: ToastrService,
    private cdr:ChangeDetectorRef,
    private modalService: NgbModal,
    private excelService: ExcelService,
    ) { }

  ngOnInit(): void {
    let clientName = localStorage.getItem("Theme");
    if (clientName === 'bnh') {
      this.hideColumn = true;
    } else if (clientName === 'mg') {
      this.hideColumn = true;
    } else {
      this.hideColumn = false;
    }
    this.Applications = Application;
    this.callDealerLogsService.dealerWiseCallHistoryRequestModal.startRecordNumber = 0;
    this.dropdownSettings = {
      singleSelection: false,
      idField: 'dealerId',
      textField: 'dealerName',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 3,
      allowSearchFilter: false,
      maxHeight: 500,
    };
    this.userService.currentUser.subscribe((resUser) => {
      resUser && this.GetDealers(resUser.id);
    });

    let todayDate = new Date();
    let formattedTodayDate = this.datePipe.transform(todayDate, 'dd/MM/yyyy');
    this.selectedDate=[];
    this.selectedDate.push(todayDate);
    this.selectedDate.push(todayDate);
    let formatted= formattedTodayDate + ' - ' + formattedTodayDate;
    this.callDealerLogsService.dealerWiseCallHistoryRequestModal.selectedDate = formatted;
  }

  async GetDealers(userId) {
    this.spinner.show();
    this.dealerList = await this.dashboardService.GetDealers(userId);
    
    const defaultDealerId = this.userService.currentUserValue.defaultDealerId;
    if (defaultDealerId && this.dealerList) {
      const defaultDealer = this.dealerList.find(dealer => dealer.dealerId === defaultDealerId);
      if (defaultDealer) {
        this.selectedDealers = [defaultDealer];
        this.callDealerLogsService.dealerWiseCallHistoryRequestModal.selectedDealers = [defaultDealerId];
      }
    }
    
    this.spinner.hide();
  }

  onRefresh() {
    this.dealerWiseCallHistoryList = [];
    this.callDealerLogsService.dealerWiseCallHistoryRequestModal.searchTerm = '';
    this.searchTerm = '';
    this.GetDealerWiseCallHistory();
  }
  onClearFilter() {
    this.dealerWiseCallHistoryList = [];
    this.callDealerLogsService.dealerWiseCallHistoryRequestModal.selectedDealers = [];
    this.selectedDealers = [];
    this.callDealerLogsService.dealerWiseCallHistoryRequestModal.sortColumn = "";
    this.callDealerLogsService.dealerWiseCallHistoryRequestModal.sortDirection = "";
    this.onDateSelectionCleared();
    let selectedDateFormatted= this.getFormattedDate(this.selectedDate);
    this.callDealerLogsService.dealerWiseCallHistoryRequestModal.selectedDate = selectedDateFormatted;
  }

  onDateRangeChanged(event: any) {
    this.selectedDate = (typeof event === 'undefined') ? [] : event;
    let selectedDateFormatted= this.getFormattedDate(this.selectedDate);
    this.dealerWiseCallHistoryList = [];
    if(selectedDateFormatted == ""){
      this.onDateSelectionCleared();
    }
    this.callDealerLogsService.dealerWiseCallHistoryRequestModal.selectedDate = selectedDateFormatted;
    this.GetDealerWiseCallHistory();
  }

  ViewDetails(Item,ApplicationId){
    const modalref = this.modalService.open(CallDealerLogsComponent, {
      size: 'lg',
      windowClass: 'EditPopup',
    });
    modalref.componentInstance.dealerId = Item?.dealerId;
    modalref.componentInstance.dealerName = Item?.dealerName;
    modalref.componentInstance.selectedDate = this.callDealerLogsService.dealerWiseCallHistoryRequestModal.selectedDate;
    modalref.componentInstance.applicationId = ApplicationId 
    modalref.result.then((response) => {
      this.onRefresh();
  });
  }

  onDateSelectionCleared(){
    let warningmsg = this.translate.instant("lblShowingLastMonthData");
    this.toaster.warning(warningmsg);      
    var date = new Date();
    let startDate = new Date(date.getFullYear(), date.getMonth() - 1, 1);
    let formattedStartDate = this.datePipe.transform(startDate, 'dd/MM/yyyy');
    let endDate = new Date();
    let formattedEndDate = this.datePipe.transform(endDate, 'dd/MM/yyyy');
    this.selectedDate=[];
    this.selectedDate.push(startDate);
    this.selectedDate.push(endDate);
    this.cdr.detectChanges();
  }

  async GetDealerWiseCallHistory() {
    this.spinner.show();
    await this.callDealerLogsService
      .GetDealerWiseCallHistory(this.callDealerLogsService.dealerWiseCallHistoryRequestModal)
      .then(
        (response) => {
          this.spinner.hide();
          this.dealerWiseCallHistoryList.push(...response.responseObject);
          if (response.responseObject?.result?.errorCode == '5449') {
            this.totalCount = 0;
          } else {
            this.totalCount =
              this.dealerWiseCallHistoryList.length > 0
                ? this.dealerWiseCallHistoryList[0].totalCount
                : 0;
          }
          this.resetPagerData(
            this.supplierInitiliseGridFromServer(
              this.dealerWiseCallHistoryList,
              this.totalCount
            )
          );
          if (this.pagerData.page > 1) {
            this.resetPagerData(
              this.initilisePagerFromServer(
                this.pagerData.page,
                this.pagerData.pagerSize,
                this.totalCount
              )
            );
          }
        },
        (_error) => {
          this.spinner.hide();
        }
      )
      .finally(() => this.spinner.hide());
  }

  resetPagerData(pageData: any) {
    this.pager = pageData.pager;
    this.pagedItems = pageData.pagedItems;
    pageData.recordSize = this.totalCount;
  }

  supplierInitiliseGridFromServer(data: any[], count: number) {
    if (data != null && data !== undefined) {
      this.dataRows = data;
      return this.refreshGridFromServer(data, count);
    }
    return this.refreshGridFromServer([], 0);
  }

  refreshGridFromServer(data: any[], count: number) {
    this.filterItems = data;
    this.filter.page = data.length === 0 ? 0 : 1;
    return this.initilisePagerFromServer(
      this.filter.page,
      Number(this.filter.pageSize),
      count
    );
  }

  initilisePagerFromServer(
    page: number,
    _pageSize: number,
    count: number = this.filterItems.length
  ) {
    let length =
      this.filterItems.length <= Constant.GridPagerSize
        ? Constant.GridPagerSize
        : this.pagerData.pagerSize;
    this.filter.pageSize = length;
    this.pager = this.pagerService.getPager(count, page, length);
    this.pagedItems = this.filterItems;
    return { pager: this.pager, pagedItems: this.pagedItems };
  }

  onChangeDealer(): void {
    this.dealerWiseCallHistoryList = [];
    let dealers = [];
    if(this.selectedDealers?.length > 0){
      dealers = this.selectedDealers.map(x=> x.dealerId)
    }
    this.callDealerLogsService.dealerWiseCallHistoryRequestModal.selectedDealers = dealers;
    this.GetDealerWiseCallHistory();
  }

  onSearchFilter() {
    this.callDealerLogsService.dealerWiseCallHistoryRequestModal.startRecordNumber = 0;
    this.callDealerLogsService.dealerWiseCallHistoryRequestModal.searchTerm =
      this.searchTerm;
    this.dealerWiseCallHistoryList = [];
    this.GetDealerWiseCallHistory();
  }

  async onSort({ column, direction }: SortEvent) {
    this.headers.forEach((header) => {
      if (header.sortable !== column) {
        header.direction = '';
      }
    });
    this.callDealerLogsService.dealerWiseCallHistoryRequestModal.sortColumn = column;
    this.callDealerLogsService.dealerWiseCallHistoryRequestModal.sortDirection =
      direction;
      this.callDealerLogsService.dealerWiseCallHistoryRequestModal.startRecordNumber = 0;
    this.dealerWiseCallHistoryList = [];
    this.GetDealerWiseCallHistory();
  }

  onScrollDown() {
    if (this.totalCount > this.dealerWiseCallHistoryList?.length) {
      this.callDealerLogsService.callDealerLogRequestModal.startRecordNumber =
        this.dealerWiseCallHistoryList.length;
      this.GetDealerWiseCallHistory();
    }
  }
  // Export functionality

  public async exportAsXLSX() {
    await this.exportData();
    if (this.dataList.length === 0) {
      return;
    }
    this.spinner.show();
    const excelData = this.mapDataForExport();
    this.excelService.exportAsExcelFile(excelData, `${this.translate.instant('lblCallDealerLog')}`);
    this.spinner.hide();
  }

  public async exportAsPDF() {
    await this.exportData();
    if (this.dataList.length === 0) {
      return;
    }
    this.spinner.show();
    const pdfData = this.mapDataForExport();
    const doc = new jsPDF('portrait');
    autoTable(doc, {
      head: [this.getHeadersForExport()],
      body: pdfData.map(row => Object.values(row)),
      margin: { top: 3, left: 3, right: 3, bottom: 3 },
      styles: { fontSize: 8, cellPadding: { top: 2, right: 15, bottom: 2, left: 2 } },
      columnStyles: {
        0: { halign: 'left', cellWidth: 22 },
        1: { halign: 'left', cellWidth: 50 },
        2: { halign: 'right', cellWidth: 44 },
        3: { halign: 'right', cellWidth: 42 },
        4: { halign: 'right', cellWidth: 46 }
      }
    });
    doc.save(`${this.translate.instant('lblCallDealerLog')}.pdf`);
    this.spinner.hide();
  }

  private async exportData(): Promise<void> {
    this.spinner.show();
    this.callDealerLogsService.dealerWiseCallHistoryRequestModal.isExport = true
    await this.callDealerLogsService.GetDealerWiseCallHistory(this.callDealerLogsService.dealerWiseCallHistoryRequestModal).then((res) => {
      if (!res || res.responseObject === 0) {
        this.toaster.error(this.translate.instant('lblDataNotAvailable'));
        this.dataList = [];
        return;
      }
      this.dataList = res.responseObject;
    }).finally(() => {
      this.callDealerLogsService.dealerWiseCallHistoryRequestModal.isExport = false
      this.spinner.hide();
    })
  }

  private mapDataForExport(): any[] {
    return this.dataList.map((item, index) => ({
      [this.translate.instant('lblNo')]: index + 1,
      [this.translate.instant('lblDealerName')]: item.dealerName,
      [this.translate.instant('lblTotalTrackerCalls')]: item.totalTrackerCalls,
      [this.translate.instant('lblTotalCheckInCalls')]: item.totalCheckInCalls,
      [this.translate.instant('lblTotalWidgetCalls')]: item.totalWidgetCalls
    }));
  }

  private getHeadersForExport(): string[] {
    return [
      this.translate.instant('lblNo'),
      this.translate.instant('lblDealerName'),
      this.translate.instant('lblTotalTrackerCalls'),
      this.translate.instant('lblTotalCheckInCalls'),
      this.translate.instant('lblTotalWidgetCalls')
    ];
  }
  getFormattedDate(dateRangeArray: any[]){
    let formattedDate: string= "";
    if(dateRangeArray.length != 0){
      let beginDate= this.datePipe.transform(dateRangeArray[0], 'dd/MM/yyyy');
      let lastDate= this.datePipe.transform(dateRangeArray[1], 'dd/MM/yyyy');
      formattedDate= beginDate + ' - ' + lastDate;
    }
    return formattedDate;
  }
}